const initializeRelatedUsers = () =>
  new Promise((resolve, reject) => {
    if (document.querySelector(".jsRelatedUsers")) {
      const ajaxs = [];
      $(".jsRelatedUsers").each((i, component) => {
        const data = $(component).data();
        const ajax = $.ajax({
          url: Routes.async_info_related_users_path(),
          type: "GET",
          data,
          success: (json) => {
            if (json.user_size == 0) {
              $(component).parent().remove();
            } else {
              $(component).replaceWith(json.html);
            }
            json.excluded_user_ids.forEach((user_id) => {
              $(`.jsUser${user_id}`).remove();
            });
          },
          error: (_XMLHttpRequest, _textStatus, _errorThrown) => {
            reject();
          },
        });
        ajaxs.push(ajax);
      });
      $.when.apply($, ajaxs).done(() => {
        resolve();
      });
    } else {
      resolve();
    }
  });

// NOTE: esbuild IIFE バンドルではモジュールスコープが分離されるため、グローバルに公開する

export default initializeRelatedUsers;
